(() => {
  const formatMoney = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  const setup = (root) => {
    if (root.dataset.volumeReady) return;
    root.dataset.volumeReady = 'true';
    let effect = null;
    let selectedSize = null;
    const choiceButtons = [...root.querySelectorAll('[data-volume-choice]')];
    const panels = [...root.querySelectorAll('[data-volume-panel]')];
    const effects = [...root.querySelectorAll('[data-volume-effect]')];
    const sizes = [...root.querySelectorAll('[data-volume-size]')];
    const sizeStep = root.querySelector('[data-volume-sizes]');
    const priceStep = root.querySelector('[data-volume-prices]');
    const selection = root.querySelector('[data-volume-selection]');
    const forms = [...document.querySelectorAll('[data-volume-form]')];
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const scrollToStep = (element) => requestAnimationFrame(() => element?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' }));
    document.body.dataset.volumeFormsReady = 'true';

    const selectRoute = (key, allowClose = false, scroll = true) => {
      const wasOpen = choiceButtons.find((button) => button.dataset.volumeChoice === key)?.getAttribute('aria-expanded') === 'true';
      const open = !(allowClose && wasOpen);
      choiceButtons.forEach((choice) => {
        const active = open && choice.dataset.volumeChoice === key;
        choice.setAttribute('aria-expanded', String(active));
        choice.classList.toggle('is-active', active);
      });
      panels.forEach((panel) => { panel.hidden = !open || panel.dataset.volumePanel !== key; });
      forms.forEach((form) => form.classList.toggle('is-active', open && form.dataset.volumeForm === key));
      if (open && scroll) scrollToStep(root.querySelector(`[data-volume-panel="${key}"]`));
    };

    choiceButtons.forEach((button) => button.addEventListener('click', () => selectRoute(button.dataset.volumeChoice, true)));
    const targetId = window.location.hash.slice(1);
    const targetForm = forms.find((form) => form.id === targetId || form.querySelector('form')?.id === targetId);
    if (targetId === 'oplages-10-99') {
      selectRoute('small', false, false);
      scrollToStep(root.querySelector('[data-volume-panel="small"]'));
    } else if (targetForm) {
      selectRoute(targetForm.dataset.volumeForm, false, false);
      const feedback = targetForm.querySelector('.contact-builder__success, .form-errors');
      if (feedback) feedback.focus({ preventScroll: true });
      scrollToStep(feedback || targetForm);
    }
    forms.forEach((form) => {
      const input = form.querySelector('[data-volume-quantity]');
      const error = form.querySelector('[data-volume-error]');
      if (!input || !error) return;
      const switchButton = error.querySelector('[data-volume-switch]');
      const guidance = error.firstChild;
      const validate = () => {
        const value = input.value.trim();
        const number = Number(value);
        let message = '';
        let canSwitch = false;
        if (value && Number.isFinite(number)) {
          if (input.dataset.volumeQuantity === 'small' && number > 99) {
            message = 'Dat is een grotere oplage. Kies 100+ stuks om ons daarover te vertellen. ';
            canSwitch = true;
          } else if (number < 10) {
            message = 'Voor deze pagina begint een oplage bij 10 stuks. Vul minimaal 10 in. ';
          } else if (input.dataset.volumeQuantity === 'large' && number < 100) {
            message = 'Dit past bij de kleinere oplage. Kies 10–99 stuks. ';
            canSwitch = true;
          }
        }
        input.setCustomValidity(message.trim());
        input.setAttribute('aria-invalid', String(Boolean(message)));
        guidance.textContent = message;
        switchButton.hidden = !canSwitch;
        error.hidden = !message;
      };
      input.addEventListener('input', validate);
      input.addEventListener('change', validate);
      input.addEventListener('invalid', validate);
      form.querySelector('form')?.addEventListener('submit', validate);
      switchButton?.addEventListener('click', () => selectRoute(switchButton.dataset.volumeSwitch));
      validate();
    });

    const renderPrices = () => {
      if (!selectedSize || !effect) return;
      const grossCents = Number(effect === 'depth-3d' ? selectedSize.dataset.depthCents : selectedSize.dataset.flipCents);
      if (!Number.isFinite(grossCents) || grossCents <= 0) { priceStep.hidden = true; return; }
      const effectLabel = effects.find((button) => button.dataset.volumeEffect === effect)?.querySelector('strong')?.textContent || '';
      selection.textContent = `${effectLabel} · ${selectedSize.dataset.volumeName}`;
      root.querySelectorAll('[data-tier-min]').forEach((row) => {
        const discount = Math.max(0, Math.min(90, Number(row.dataset.tierDiscount) || 0));
        const unit = Math.round((grossCents / 1.21) * (1 - discount / 100)) / 100;
        const minimum = Number(row.dataset.tierMin);
        row.querySelector('[data-tier-percent]').textContent = `${discount}%`;
        row.querySelector('[data-tier-unit]').textContent = formatMoney.format(unit);
        row.querySelector('[data-tier-total]').textContent = formatMoney.format(unit * minimum);
      });
      priceStep.hidden = false;
    };

    effects.forEach((button) => button.addEventListener('click', () => {
      effect = button.dataset.volumeEffect;
      effects.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      sizeStep.hidden = false;
      renderPrices();
      scrollToStep(sizeStep);
    }));
    sizes.forEach((button) => button.addEventListener('click', () => {
      selectedSize = button;
      sizes.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      renderPrices();
      scrollToStep(priceStep);
    }));
  };
  const start = (scope = document) => scope.querySelectorAll('[data-volume-selector]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true }); else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
